<template>
  <div class="magicstone-scan-page">
    <img class="logo" src="/static/images/magicstone/ms-logo.png" />
    <img class="system" src="/static/images/magicstone/ms-system.png" />
    <div class="white-box">
      <div class="left-box">
        <div class="info-line">
          <span class="info-label">产品真伪：</span>
        </div>
        <div class="info-line">
          <span class="info-label">首次查询时间：</span>
        </div>
        <div class="info-line">
          <span class="info-label">最近查询时间：</span>
        </div>
      </div>
      <div class="right-box">
        <div class="info-line">
          <span class="info-value">{{ queryResult }}</span>
        </div>
        <div class="info-line">
          <span class="info-value">{{ firstQueryTime }}</span>
        </div>
        <div class="info-line">
          <span class="info-value">{{ preQueryTime || firstQueryTime }}</span>
        </div>
      </div>
    </div>
    <button v-if="showButtons" @click="handleQueryTrace" class="action-button">查看详细溯源信息</button>
    <div class="bottom-container">
      <img class="bottom" src="/static/images/magicstone/ms-bottom.png" />
    </div>
    <div class="bottom-overlay"></div>
  </div>
</template>

<style scoped>
.magicstone-scan-page {
  width: 100vw;
  height: 100vh;
  background-color: rgb(175, 244, 39);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  position: relative;
}

.logo {
  margin-top: 7vh;
  width: 30vw;
  height: auto;
}

.system {
  margin-top: 4vh;
  width: 75vw;
  height: auto;
}

.white-box {
  margin-top: auto;
  width: 85vw;
  height: 30vh;
  background-color: white;
  border-radius: 8px;
  display: flex;
  padding: 3vh 4vw 3vh 4vw;
}

.left-box {
  width: 30vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.right-box {
  width: 50vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-line {
  display: flex;
  align-items: center;
  margin-bottom: 2vh;
  min-height: 6vh;
}

.info-line:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 3.8vw;
  color: black;
  text-align: justify;
  text-align-last: justify;
  width: 100%;
}

.info-value {
  font-size: 3.8vw;
  color: black;
  text-align: left;
  width: 100%;
}

.action-button {
  margin-top: 5vh;
  width: 80vw;
  height: 6vh;
  background: linear-gradient(to bottom, rgb(242, 240, 73), rgb(146, 212, 13));
  border: none;
  border-radius: 14px;
  color: black;
  font-size: 4.5vw;
  font-weight: bold;
  cursor: pointer;
  outline: none;
  letter-spacing: 0.5vw;
}

.bottom-container {
  margin-top: auto;
  margin-bottom: 1vh;
  position: relative;
  width: 60vw;
}

.bottom {
  width: 60vw;
  height: auto;
  position: relative;
  z-index: 2;
}

.bottom-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 7vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.scan-text {
  margin-top: 5vh;
  font-size: 6.2vw;
  letter-spacing: 2vw;
}

.scan-img {
  margin-top: 8vh;
  width: 40vw;
  height: auto;
}

.tip-text {
  margin-top: 4vh;
  color: black;
  font-size: 4.2vw;
}

.query-container {
  margin-top: 2.5vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.query-box {
  display: flex;
  width: 76vw;
  overflow: hidden;
}

.query-input {
  flex: 1;
  height: 6vh;
  border: 1.5px solid black;
  border-right: none;
  padding: 0 3vw;
  font-size: 4vw;
  background: white;
  color: #333;
  outline: none;
}

.query-button {
  width: 20vw;
  height: 6vh;
  background: black;
  color: white;
  border: none;
  font-size: 4.5vw;
  font-weight: bold;
  cursor: pointer;
  outline: none;
}
</style>

<script>
import { queryAnti, getInfoByCode } from '../../api/api'
export default {
  name: 'MagicStoneResult',
  data() {
    return {
      eno: process.env.ENV_NUM === '1' ? '138495222640' : '138603493800',
      code: '',
      queryResult: '',
      firstQueryTime: '',
      preQueryTime: '',
      deptId: '',
      showButtons: false,
      digitCode: ''
    }
  },
  methods: {
    handleQueryTrace() {
      this.$router.push({
        path: '/magicstone/trace',
        query: {
          eno: this.eno,
          c: this.code
        }
      });
    },
    async queryAntiCode() {
      if (this.code && this.eno) {
        try {
          const res = await queryAnti(this.code, this.eno);
          const data = res.data;

          if (data == null || data.code == "500") {
            this.queryResult = "查询异常，请重新扫描防伪码进行查询";
            this.showButtons = false;
            return;
          }

          const replyCode = data.data.replyCode;

          if (replyCode === "300101" || replyCode === "300102") {
            this.queryResult = "产品为正品，请放心使用";
            this.firstQueryTime = data.data.firstQueryTime || '';
            this.preQueryTime = data.data.preQueryTime || '';
            this.deptId = data.data.deptId || '';
            this.showButtons = true;
          } else if (replyCode === "300106") {
            this.queryResult = "您查询的数码不存在！";
            this.showButtons = false;
          } else {
            this.queryResult = "查询结果异常，请联系客服";
            this.showButtons = false;
          }
        } catch (error) {
          console.error('防伪查询失败:', error);
          this.queryResult = "查询失败，请稍后重试";
          this.showButtons = false;
        }
      } else {
        this.queryResult = "请使用正确入口进入进行查询";
        this.showButtons = false;
      }
    }
  },
  mounted() {
    const code = this.$route.query.c;
    
    if (code) {
      this.code = code ? code.substring(0, 16) : '';
    }
    this.queryAntiCode();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MagicStone/Index.vue